<template>
  <div class="fu-step">
    <div class="fu-step-header">
      <button type="button" class="fu-back-btn" @click="$emit('go-back')" t_label="btn_emp2_Back_ForgotUsernameEmail">
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/All_Categories.svg" 
          alt="back" 
          class="fu-back-icon"
        />
      </button>
      <h1 class="fu-step-title">{{ $t('lbl_emp2_RetrieveUsername') }}</h1>
    </div>

    <div class="fu-form-group">
      <div class="fu-info-text" v-html="$t('lbl_emp2_EnterAdminEmailForUsername')">
      </div>
    </div>

    <div class="fu-form-group">
      <div class="fu-input-wrapper">
        <div class="fu-input-container">
          <!-- 浮动标签（有值、错误或聚焦时显示在边框上方） -->
          <label
            v-if="shouldShowLabel(email, emailError)"
            class="input-label"
            :class="{ 'label-error': emailError }"
          >
            {{ $t('lbl_emp2_Email') }} <span class="required">*</span>
          </label>
          <!-- 占位符（无值且无错误且未聚焦时显示在输入框内部） -->
          <span
            v-if="shouldShowPlaceholder(email, emailError)"
            class="input-placeholder"
          >
            {{ $t('lbl_emp2_Email') }} <span class="required">*</span>
          </span>
          <input
            :value="email"
            type="email"
            name="email"
            id="forgot-username-email-field"
            autocomplete="email"
            class="form-input-placeholder"
            :class="{ 'input-error': emailError }"
            placeholder=""
            @focus="() => onFocus('clear-error')"
            @blur="onBlur"
            @input="handleInput"
          />
        </div>
        <div v-if="emailError" class="fu-error-message">
          {{ $t('lbl_emp2_InvalidEmail') }}
        </div>
      </div>
    </div>

    <button
      class="fu-btn-primary"
      @click="$emit('continue')"
      :disabled="!isValidEmail || loading"
      t_label="btn_emp2_Continue_ForgotUsernameEmail"
    >
      {{ $t('lbl_emp2_Continue') }}
    </button>
  </div>
</template>

<script>
import inputMixin from '../Common/input-mixin.js';
import { validateEmail } from '../Common/utils.js';

export default {
  name: 'ForgotUsernameEmail',
  mixins: [inputMixin],
  props: {
    email: {
      type: String,
      default: ''
    },
    emailError: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isValidEmail() {
      return validateEmail(this.email);
    }
  },
  methods: {
    handleInput(event) {
      this.handleInputGeneric(event, 'update:email', 'clear-error');
    }
  }
};
</script>

<style>
@import '../Common/new-login-shared.css';
</style>

<style scoped>
/* 组件特定样式覆盖：只保留容器本身的定位，输入和标签样式使用共享文件 */
.fu-label-wrapper {
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  margin-bottom: 8px;
  padding: 0;
}

.fu-input-container {
  width: 100%;
  position: relative;
  overflow: visible;
  background: transparent;
}

.fu-input-container.fu-input-error {
  outline-color: #CD1515 !important;
}
</style>

